import { useCallback } from 'react'

const useFileToBase64 = () =>
  useCallback(
    file =>
      new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.onloadend = () => resolve(fileReader.result)
        fileReader.onerror = reject
        fileReader.readAsDataURL(file)
      }),
    []
  )

export default useFileToBase64
